export default __webpack_public_path__ + "static/media/97.fd41b78f.jpg";